const ALL = [["off", "Off"], ["optional", "Optional"], ["required", "Required"]];
const NO_REQUIRED = ALL.slice(0, 2);
const FIELDS = [
  { key: "email_field", id: "email", label: "Email", modes: ALL },
  { key: "phone_field", id: "phone", label: "Phone", modes: ALL },
  { key: "note_field", id: "note", label: "Private note to host", hint: "Only you can see it", modes: NO_REQUIRED },
  { key: "comment_field", id: "comment", label: "Public comment", hint: "Shown on the guest list", modes: NO_REQUIRED },
];

export const RsvpFieldsPicker = ({ form, onChange }) => (
  <div className="divide-y divide-slate-100 rounded-xl border border-slate-200" data-testid="rsvp-fields-picker">
    <div className="flex items-center justify-between gap-3 px-4 py-3">
      <span className="text-sm font-semibold text-slate-900">Name</span>
      <span data-testid="rsvp-field-name-required" className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600">Always required</span>
    </div>
    {FIELDS.map(({ key, id, label, hint, modes }) => (
      <div key={key} className="flex flex-wrap items-center justify-between gap-3 px-4 py-3">
        <span>
          <span className="block text-sm font-semibold text-slate-900">{label}</span>
          {hint && <span className="block text-xs text-slate-500">{hint}</span>}
        </span>
        <div className="inline-flex rounded-lg bg-slate-100 p-1" role="radiogroup" aria-label={`${label} field`}>
          {modes.map(([mode, text]) => (
            <button
              key={mode}
              type="button"
              role="radio"
              aria-checked={form[key] === mode}
              data-testid={`rsvp-field-${id}-${mode}`}
              onClick={() => onChange(key, mode)}
              className={`rounded-md px-3 py-1.5 text-xs font-semibold transition-[background-color,color] duration-200 ${
                form[key] === mode ? "bg-white text-blue-700 shadow-sm" : "text-slate-500 hover:text-slate-800"
              }`}
            >
              {text}
            </button>
          ))}
        </div>
      </div>
    ))}
  </div>
);
